import { Pipe, PipeTransform } from '@angular/core';
import { PCXConstants } from '../../sc-config/constant/PCXConstants';

@Pipe({
    name: 'userActivityStatus',
    standalone: false
})
export class UserActivityStatusPipe implements PipeTransform {
  
  transform(lastActiveTime: string | Date | null): boolean {
    // If no last active time, user is not active
    if (!lastActiveTime) {
      return false;
    }

    // Handle the default "0001-01-01T00:00:00Z" case
    if (lastActiveTime === '0001-01-01T00:00:00Z') {
      return false;
    }

    try {
      // Convert to Date object if it's a string
      const lastActiveDate = typeof lastActiveTime === 'string' 
        ? new Date(lastActiveTime) 
        : lastActiveTime;

      // Get current time
      const currentTime = new Date();
      
      // Calculate time difference in minutes
      const timeDifferenceInMinutes = (currentTime.getTime() - lastActiveDate.getTime()) / (1000 * 60);
      
      // Get the threshold from PCXConstants
      const activeThresholdMinutes = PCXConstants.UserActivity.IS_ACTIVE_CHECK_TIME_IN_MIN;
      
      // Return true if user was active within the threshold
      return timeDifferenceInMinutes <= activeThresholdMinutes;
      
    } catch (error) {
      console.error('Error in UserActivityStatusPipe:', error);
      return false;
    }
  }
}